import { Context } from '@databases/types/redux';

import { ContextAppState } from './actions';

export function getContext(state: ContextAppState): Context {
  if (!state.context.context) {
    throw new Error('Context is not initialized.');
  }
  return state.context.context;
}

export function selectCurrentSpaceKey(state: ContextAppState): string {
  return getContext(state).space.key;
}

export function selectBaseUrl(state: ContextAppState): string {
  return getContext(state).baseUrl;
}

export function selectCurrentContent(state: ContextAppState): Context['content'] {
  return getContext(state).content;
}

export function selectCurrentUserId(state: ContextAppState): string | undefined {
  return getContext(state).userId;
}
